import React, { useEffect } from "react"; // ✅ Import useEffect
import { trackPageView } from "./analytics"; // ✅ Import tracking function

import BiotechTable from "./BiotechTable";
import Header from "./Header";
import './App.css';

function App() {
    useEffect(() => {
        trackPageView(); // ✅ Track when the page loads
    }, []);

    return (
        <div className="App">
            <Header />
            <BiotechTable/>
        </div>
    );
}

export default App;
